export class MapPopupStyle {
  minWidth = 0;
  maxWidth = 0;
  maxHeight = 0;
  padding = 0;
  textAlignment = 'none';
  offsetX = 0;
  offsetY = 0;
  contentMaxLines = 0;

  static normalize(styles: Partial<MapPopupStyle> | null | undefined): MapPopupStyle {
    const pureStyles = new MapPopupStyle();

    pureStyles.minWidth = styles?.minWidth ?? pureStyles.minWidth;
    pureStyles.maxWidth = styles?.maxWidth ?? pureStyles.maxWidth;
    pureStyles.maxHeight = styles?.maxHeight ?? pureStyles.maxHeight;
    pureStyles.padding = styles?.padding ?? pureStyles.padding;
    pureStyles.textAlignment = styles?.textAlignment ?? pureStyles.textAlignment;
    pureStyles.offsetX = styles?.offsetX ?? pureStyles.offsetX;
    pureStyles.offsetY = styles?.offsetY ?? pureStyles.offsetY;
    pureStyles.contentMaxLines = styles?.contentMaxLines ?? pureStyles.contentMaxLines;

    return pureStyles;
  }
}
